module.exports = __webpack_public_path__ + "static/img/part3.bed9296.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/zh/part3.png
// module id = MstG
// module chunks = 0